/** Cross-route ABAC navigation loader (survives Multi Access modal unmount). */

let active = false;
const listeners = new Set();

export function isAbacNavLoaderActive() {
  return active;
}

export function showAbacNavLoader() {
  if (active) return;
  active = true;
  listeners.forEach((listener) => listener(true));
}

export function hideAbacNavLoader() {
  if (!active) return;
  active = false;
  listeners.forEach((listener) => listener(false));
}

export function subscribeAbacNavLoader(listener) {
  listeners.add(listener);
  listener(active);
  return () => {
    listeners.delete(listener);
  };
}
